import React, { Component } from "react"
import Layout from "../components/Layout"
import StyledHero from "../components/StyledHero"
import Projects from "../components/Projects/Projects"
import { graphql } from "gatsby"


export default class projects extends Component {
  render() {
    return (
      <Layout>
      
  
        <Projects />
      </Layout>
    )
  }
}
{/* <StyledHero img={this.props.data.defaultBcg.childImageSharp.fluid} /> */}
export const query = graphql`
  query {
    defaultBcg: file(relativePath: { eq: "hustle.jpg" }) {
      childImageSharp {
        fluid(quality: 90, maxWidth: 4160) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
  }
`
